import { createContext, useState, useEffect } from "react";

const PopUpContext = createContext({
	popUp: null,
	showPopUp: () => {},
	hidePopUp: () => {},
});

export const PopUpContextProvider = ({ children }) => {
	const [activePopUP, setActivePopUp] = useState();

	useEffect(() => {
		if (activePopUP) {
			const timer = setTimeout(() => {
				setActivePopUp(null);
			}, 3000);

			return () => {
				clearTimeout(timer);
			};
		}
	}, [activePopUP]);

	const showPopUpHandler = (popUpData) => {
		setActivePopUp(popUpData);
	};

	const hidePopUpHandler = () => {
		setActivePopUp(null);
	};

	const context = {
		popUp: activePopUP,
		showPopUp: showPopUpHandler,
		hidePopUp: hidePopUpHandler,
	};

	return (
		<PopUpContext.Provider value={context}>{children}</PopUpContext.Provider>
	);
};

export default PopUpContext;
